/**
 * When indexing a question in program Key, you should also index it in all
 * affiliated programs.
 **/
export const affiliatedPrograms = {
    V5RC: ["V5RC", "VURC", "VAIRC"],
    VURC: ["VURC", "VAIRC"],
    VAIRC: ["VAIRC"],
    VIQRC: ["VIQRC"],
};
/**
 * Inverse of `affiliatedPrograms`, this maps each program to the
 * programs that are related to it.
 **/
export const relatedPrograms = {
    V5RC: ["V5RC"],
    VURC: ["V5RC", "VURC"],
    VAIRC: ["V5RC", "VURC", "VAIRC"],
    VIQRC: ["VIQRC"],
};
//# sourceMappingURL=programs.js.map